/**
 * Internal Dependencies
 */
import metadata from './block.json';
const { name } = metadata;

export { name, metadata };
